import { render, staticRenderFns } from "./Sim.vue?vue&type=template&id=740e83d1&scoped=true"
import script from "./Sim.vue?vue&type=script&lang=js"
export * from "./Sim.vue?vue&type=script&lang=js"
import style0 from "./Sim.vue?vue&type=style&index=0&id=740e83d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e83d1",
  null
  
)

export default component.exports